import { render, staticRenderFns } from "./ProjectDetailsOverlay.vue?vue&type=template&id=5838bc12&scoped=true"
import script from "./ProjectDetailsOverlay.vue?vue&type=script&lang=ts"
export * from "./ProjectDetailsOverlay.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDetailsOverlay.vue?vue&type=style&index=0&id=5838bc12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838bc12",
  null
  
)

export default component.exports